import {
  IDragHandler,
  IIdleHandler,
  ILimitMaxBounds,
  ISetMapInitialView,
  ISetZoom,
} from '../types';
import { getNaverMaps } from '../utils';

export const setZoom = ({ map, forLarge }: ISetZoom) => {
  if (!map) return;
  const currentZoom = map.getZoom();
  const nextZoom = forLarge ? currentZoom + 1 : currentZoom - 1;
  map.setZoom(nextZoom);
};

const dragHandler = ({ map, initialBounds, centerRef }: IDragHandler) => {
  if (!centerRef.current) return;

  const naverMaps = getNaverMaps();
  const currentCenter = map.getCenter() as naver.maps.LatLng;
  const currentBounds = map.getBounds();
  const isYOut =
    currentBounds.maxY() >= initialBounds.getMax().y ||
    currentBounds.minY() <= initialBounds.getMin().y;
  if (isYOut) {
    const newCenter = naverMaps.LatLng({
      lat: centerRef.current.lat(),
      lng: currentCenter.lng(),
    });
    map.setCenter(newCenter);
  } else {
    centerRef.current = currentCenter;
  }
};

const idleHandler = ({ map, initialBounds, centerRef }: IIdleHandler) => {
  if (!centerRef.current) return;

  const naverMaps = getNaverMaps();
  const max = initialBounds.getMax();
  const min = initialBounds.getMin();
  const currentCenter = map.getCenter() as naver.maps.LatLng;
  const currentBounds = map.getBounds();
  const lat = currentCenter.lat();
  const lng = currentCenter.lng();
  const isYOutMax = currentBounds.maxY() >= max.y;
  const isYOutMin = currentBounds.minY() <= min.y;
  if (isYOutMax && isYOutMin) {
    const newCenter = naverMaps.LatLng({
      lat: 0,
      lng,
    });
    map.setCenter(newCenter);
  } else if (isYOutMax) {
    const dy = currentBounds.maxY() - max.y;
    const newCenter = naverMaps.LatLng({
      lat: lat - dy - 1,
      lng,
    });
    map.setCenter(newCenter);
  } else if (isYOutMin) {
    const dy = currentBounds.minY() - min.y;
    const newCenter = naverMaps.LatLng({
      lat: lat - dy + 1,
      lng,
    });
    map.setCenter(newCenter);
  } else {
    centerRef.current = currentCenter;
  }
};

export const limitMaxBounds = ({
  map,
  initialBounds,
  centerRef,
}: ILimitMaxBounds) => {
  const naverMaps = getNaverMaps();

  // 드래그할 때 남북극을 넘어 위아래로 움직이지 않도록 하는 함수
  naverMaps.Event.addListener(map, 'drag', () => {
    dragHandler({ map, initialBounds, centerRef });
  });

  // 축소/확대 할 때 남북극 경계를 벗어나지 않도록 하는 함수
  naverMaps.Event.addListener(map, 'idle', () => {
    idleHandler({ map, initialBounds, centerRef });
  });
};

export const setMapInitialView = ({ map, markers }: ISetMapInitialView) => {
  if (!map) return;
  if (!markers.length) return;

  const naverMaps = getNaverMaps();
  if (markers.length === 1) {
    map.morph(markers[0].getPosition(), 4);
    return;
  }
  const xPositions = markers.map(item => item.getPosition().x);
  const yPositions = markers.map(item => item.getPosition().y);

  const min = [Math.min(...xPositions), Math.min(...yPositions)];
  const max = [Math.max(...xPositions), Math.max(...yPositions)];

  map.panToBounds(new naverMaps.LatLngBounds(min, max));
};

export default {
  dragHandler,
  limitMaxBounds,
  setMapInitialView,
  setZoom,
};
